import React, { useEffect } from 'react';

import { colors, layout } from 'Constants';

// State
import { ApiStore } from 'Store';
import { Subscribe } from 'laco-react';

import { Container, Header, Anchor } from 'Components/core';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import CODES from 'Root/libs/analytics/CodeDef';
import Api from 'Root/libs/analytics/Api';
import { replaceAnchor } from 'Root/libs/anchor';
export default ()=>{

  useEffect(()=>{
    Api.recordAcitity(CODES.MENU_BD);
  },[]);

  return (
    <Subscribe to={[ApiStore]}>
      {state => {
        let resource = state.vaInOut?.resource;

        return (
          <Container
            seperation="32px"
            column
            maxWidth
            style={{ margin: 'auto', padding: '32px' }}
          >
            <Header>Important In Out information</Header>
            
            <Container seperation="16px" >
              <p dangerouslySetInnerHTML={{__html:replaceAnchor(resource?.summary)}}></p>
            </Container>
       
          </Container>
        );
      }}
    </Subscribe>
  );
};

